import type { DecisionMakerResponsePageState } from './types';

export const mutations = {
	toggleBeforeSuggestedPetitions: (
		state: DecisionMakerResponsePageState,
		beforeSuggestedPetitions: boolean,
	): DecisionMakerResponsePageState => ({
		...state,
		beforeSuggestedPetitions,
	}),
};
